import { getApolloClient } from '../lib/getApolloClient';
import { GET_RATING_FOR_USER_ID } from './rating.gql';

export const fetchRatingForUserId = async (userId: string) => {
  try {
    const { data } = await getApolloClient().query({
      query: GET_RATING_FOR_USER_ID,
      variables: { userId },
    });
    return data.getCurrentRatingForUser;
  } catch (error) {
    console.error('Error fetching rating for current user:', error);
    return null;
  }
};

export const ratingActions = {
  fetchRatingForUserId,
};
